import { MessageResponseWithBlocks } from "@/components/ai-elements/message-response-with-blocks";
import {
  Plan,
  PlanContent,
  PlanDescription,
  PlanFooter,
  PlanHeader,
  PlanTitle,
  PlanTrigger,
} from "@/components/ai-elements/plan";
import { ButtonLoading } from "@/components/button-loading";
import { useTranslation } from "@/hooks/useTranslation";

type ConversationGenerationPlanProps = {
  isGenerating: boolean;
  isPlanOpen: boolean;
  onPlanOpenChange: (open: boolean) => void;
  editableGenerated: string;
  isSaving: boolean;
  onSave: () => void;
};

export function ConversationGenerationPlan({
  isGenerating,
  isPlanOpen,
  onPlanOpenChange,
  editableGenerated,
  isSaving,
  onSave,
}: ConversationGenerationPlanProps): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <Plan
      isStreaming={isGenerating}
      open={isPlanOpen}
      onOpenChange={onPlanOpenChange}
    >
      <PlanHeader>
        <div className="flex-1 space-y-1.5">
          <PlanTitle>
            {t(
              isGenerating
                ? "team.components.instruction.conversation.plan.generatingTitle"
                : "team.components.instruction.conversation.plan.title"
            )}
          </PlanTitle>
          <PlanDescription>
            {t(
              "team.components.instruction.conversation.plan.description"
            )}
          </PlanDescription>
        </div>
        <PlanTrigger />
      </PlanHeader>
      <PlanContent>
        <div className="prose prose-sm max-w-none ai-html-content">
          <MessageResponseWithBlocks isStreaming={isGenerating}>
            {editableGenerated}
          </MessageResponseWithBlocks>
        </div>
      </PlanContent>
      <PlanFooter>
        <ButtonLoading
          onClick={onSave}
          isLoading={isSaving}
          disabled={isGenerating || !editableGenerated.trim()}
          size="sm"
        >
          {t("team.components.instruction.conversation.saveButton")}
        </ButtonLoading>
      </PlanFooter>
    </Plan>
  );
}
